module.exports = __webpack_public_path__ + "media/yl.c1aa225a.mp4";